module.exports = __webpack_public_path__ + "assets/profileIcon-e85cd7.svg";